import * as React from 'react'
import { ReactComponent as IconSolidWallLayer } from '../icons/IconSolidWallLayer.svg'
import { ReactComponent as IconFramedWallLayer } from '../icons/IconFramedWallLayer.svg'
import { ReactComponent as IconSolidHorizLayer } from '../icons/IconSolidHorizLayer.svg'
import { ReactComponent as IconFramingLayer } from '../icons/IconFramingLayer.svg'
import { ReactComponent as IconColumnLayer } from '../icons/IconColumnLayer.svg'
import { ReactComponent as IconMetalDeckLayer } from '../icons/IconMetalDeckLayer.svg'
import { AssemblyHorizontal, WallType, kind } from '../internalModules'
import { Box } from '@mui/material'

type Props = {
  layerKind: string
  assembly: WallType
}

export default function UILayerDialogGraphics({layerKind, assembly}: Props) {
  const horizontal = assembly instanceof AssemblyHorizontal
  const imageSize = 400

  function showSolidGraphic(){
    if (layerKind === kind.solid && !horizontal){
      return(
        <IconSolidWallLayer height={imageSize}/>
      )
    }
    else { return(<></>)}
  }

  function showFramedGraphic(){
    if (layerKind === kind.framed) {
      return(
        <IconFramedWallLayer height={imageSize}/>
      )
    }
    else { return(<></>)}
  }

  function showFramingGraphic(){
    if (layerKind === kind.framing) {
      return(
        <IconFramingLayer height={imageSize}/>
      )
    }
    else { return(<></>)}
  }

  function showSolidHorizGraphic(){
    if (layerKind === kind.solid && horizontal) {
      return(
        <IconSolidHorizLayer height={imageSize}/>
      )
    }
    else { return(<></>)}
  }

  function showColumnGraphic(){
    if (layerKind === kind.column) {
      return(
        <IconColumnLayer height={imageSize}/>
      )
    }
    else { return(<></>)}
  }

  function showMetalDeckGraphic(){
    if (layerKind === kind.mDeck) {
      return(
        <IconMetalDeckLayer height={imageSize}/>
      )
    }
    else { return(<></>)}
  }

  return(
    <Box marginBottom={4} display='flex' justifyContent='center' alignItems='center'>
      {showSolidGraphic()}
      {showFramedGraphic()}
      {showFramingGraphic()}
      {showSolidHorizGraphic()}
      {showColumnGraphic()}
      {showMetalDeckGraphic()}
    </Box>
  )
}